var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * BeoCalendar is custom made Calendar component.
 *
 * @author rajeev.k
 * @description This component is an extension of PrimeReact Calendar tag (<Calendar/>).
 * All properties of PrimeReact Calendar can be used by this BeoCalendar component.
 * typ BeoCalendarTyp is defined to make id attribute required.
 * localization is implemented for this component
 */
import { useBEOController } from "@context/BeoContext";
import { Calendar } from "primereact/calendar";
import { classNames } from "primereact/utils";
var BeoCalendar = function (_a) {
    var _b, _c, _d;
    var id = _a.id, _e = _a.width, width = _e === void 0 ? "full" : _e, ref = _a.ref, props = __rest(_a, ["id", "width", "ref"]);
    var controller = useBEOController()[0];
    return (_jsx(Calendar, __assign({ id: id, ref: ref, dateFormat: (_b = props.dateFormat) !== null && _b !== void 0 ? _b : "dd/mm/yy", showTime: (_c = props.showTime) !== null && _c !== void 0 ? _c : false, hourFormat: (_d = props.hourFormat) !== null && _d !== void 0 ? _d : "12", locale: controller.locale, hideOnDateTimeSelect: true, className: "w-".concat(width, " custom-height ").concat(props.className) }, props, { pt: {
            yearPicker: {
                className: classNames("my-1"),
            },
            panel: function (_a) {
                var props = _a.props;
                return ({
                    className: classNames("bg-white dark:bg-gray-900", "min-w-min", {
                        "shadow-md border-0 absolute": !props.inline,
                        "inline-block overflow-x-auto border border-gray-300 dark:border-blue-900/40 p-2 rounded-lg": props.inline,
                    }),
                });
            },
            day: { className: "p-1" },
            dayLabel: function (_a) {
                var context = _a.context;
                return ({
                    className: classNames("w-5 h-5 rounded-full transition-shadow duration-200 border-transparent border", "flex items-center justify-center mx-auto overflow-hidden relative", "focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]", {
                        "opacity-60 cursor-default": context.disabled,
                        "cursor-pointer": !context.disabled,
                    }, {
                        "text-gray-600 dark:text-white/70 bg-transprent hover:bg-gray-200 dark:hover:bg-gray-800/80": !context.selected && !context.disabled,
                        "text-blue-700 bg-blue-100 hover:bg-blue-200": context.selected && !context.disabled,
                    }),
                });
            },
            timePicker: {
                className: classNames("flex justify-center items-center", "border-t-1 border-solid border-gray-300 p-2"),
            },
            separatorContainer: { className: "flex items-center flex-col" },
            separator: { className: "text-sm" },
            hourPicker: { className: "flex items-center flex-col" },
            minutePicker: { className: "flex items-center flex-col" },
            ampmPicker: { className: "flex items-center flex-col" },
            incrementButton: {
                className: classNames("flex items-center justify-center cursor-pointer overflow-hidden relative", "w-3 h-3 text-gray-600 dark:text-white/70 border-0 bg-transparent rounded-full transition-colors duration-200 ease-in-out", "hover:text-gray-700 dark:hover:text-white/80 hover:border-transparent hover:bg-gray-200 dark:hover:bg-gray-800/80 "),
            },
            decrementButton: {
                className: classNames("flex items-center justify-center cursor-pointer overflow-hidden relative", "w-3 h-3 text-gray-600 dark:text-white/70 border-0 bg-transparent rounded-full transition-colors duration-200 ease-in-out", "hover:text-gray-700 dark:hover:text-white/80 hover:border-transparent hover:bg-gray-200 dark:hover:bg-gray-800/80 "),
            },
            tableHeaderCell: { className: "p-1" },
        } })));
};
export default BeoCalendar;
